/*
 * _customled-accessory-quickview-bridge.js  (Maranello M1.10.x)
 *
 * Click-delegation bridge that routes accessory-tile clicks to Maranello's
 * NATIVE <quick-view-drawer> (assets/quick-view-drawer.js +
 * snippets/quick-view-drawer.liquid). Loaded only on product templates.
 *
 * Why a bridge instead of native triggers:
 *   - Maranello's drawer is triggered by a <drawer-toggle for="QuickViewDrawer">
 *     button placed INSIDE a .card-product (the drawer's open() calls
 *     opener.closest('.card-product') to find the product context).
 *   - Our accessory grid's "QUICK VIEW" button is rendered as a SIBLING of
 *     card-product (so the card-product snippet stays untouched). The
 *     button is therefore not a descendant of .card-product, and the
 *     drawer's default lookup would fail.
 *   - This bridge intercepts all relevant clicks on accessory tiles,
 *     finds the sibling .card-product inside the same .grid-item, and
 *     passes a descendant element (the existing .js-product-link) as
 *     the opener so the drawer's lookup succeeds.
 *
 * Intercepts:
 *   - Clicks on the "QUICK VIEW" button
 *     (.customled-accessory-grid__quickview-btn)
 *   - Clicks on the product image link or title link inside
 *     .customled-accessory-grid .card-product (so EVERY click on an
 *     accessory tile opens quick-view instead of navigating to PDP)
 *
 * Falls back to default navigation if the drawer is not present (defensive
 * — should not happen on PDPs after this script ships).
 */
(function () {
  "use strict";

  // Move the .customled-accessory-grid__actions block from its initial
  // sibling-of-card-product position INTO the card-product itself, so
  // the button sits visually inside the tile (same slot Maranello's
  // native quick-view button would occupy).
  function relocateActionBlocks() {
    var lis = document.querySelectorAll(".customled-accessory-grid .grid-item");
    for (var i = 0; i < lis.length; i++) {
      var li = lis[i];
      var card = li.querySelector(".card-product");
      var actions = li.querySelector(":scope > .customled-accessory-grid__actions");
      if (!card || !actions) continue;
      // Target the card's existing info wrap if present so the button
      // ends up in the canonical card-footer area; otherwise append to
      // the card root.
      var slot =
        card.querySelector(".card-info-wrap") ||
        card.querySelector(".card-info") ||
        card;
      slot.appendChild(actions);
    }
  }

  function init() {
    relocateActionBlocks();

    // The cart drawer is re-rendered after every cart add via Shopify's
    // section-rendering API — those fresh tiles weren't in the DOM when
    // init first ran. Use a MutationObserver to re-relocate whenever a
    // new .customled-accessory-grid appears (covers the cart drawer's
    // content swap as well as any other dynamic insertion).
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.matches && node.matches(".customled-accessory-grid")) ||
            (node.querySelector && node.querySelector(".customled-accessory-grid"))
          ) {
            relocateActionBlocks();
            return; // one pass per mutation batch is enough
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener("click", function (e) {
      var grid = e.target.closest && e.target.closest(".customled-accessory-grid");
      if (!grid) return;

      // Resolve the .card-product for the clicked tile.
      var card = null;
      var clickedAnchor = e.target.closest("a[href]");
      if (clickedAnchor) {
        // Click was on a link inside the card (image or title anchor).
        card = clickedAnchor.closest(".card-product");
      }
      if (!card) {
        // Click was on our Quick View button (sibling of .card-product).
        var li = e.target.closest(".grid-item, li");
        if (li) card = li.querySelector(".card-product");
      }
      if (!card) return;

      // Find the standard product link descendant the drawer expects.
      var opener = card.querySelector(".js-product-link");
      if (!opener) return;

      var drawer = document.getElementById("QuickViewDrawer");
      if (!drawer || typeof drawer.open !== "function") {
        // Drawer not on page (settings issue or load order race).
        // Let the default navigation happen rather than swallowing the click.
        return;
      }

      e.preventDefault();
      drawer.open(opener);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
